import { ApiResponse } from './Api';

// Mock data for development/testing
const mockData = {
  root: {
    message: "Welcome to CDCHK API",
    version: "1.0.0"
  },
  rateLimit: {
    limit: 1000,
    remaining: 999,
    reset: Date.now() + 3600000
  },
  user: {
    id: 1,
    name: "Test User",
    email: "test@example.com"
  },
  login: {
    access_token: "mock_access_token_12345",
    user: {
      id: 1,
      name: "Test User",
      email: "test@example.com"
    }
  },
  children: [
    {
      id: 1,
      name: "Test Child",
      age: 5
    }
  ],
  appointments: [
    {
      id: 1,
      title: "Test Appointment",
      date: "2024-01-15T10:00:00Z"
    }
  ],
  announcements: [
    {
      id: 1,
      title: "Test Announcement",
      content: "This is a test announcement"
    }
  ]
};

export default {
  // Functions return fixtures
  getRoot: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.root
    };
  },
  
  getRate: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.rateLimit
    };
  },
  
  getUser: async (username: string): Promise<ApiResponse> => {
    // This fixture only supports 'test' or else returns default user
    const userData = username.toLowerCase() === 'test' ? mockData.user : { ...mockData.user, name: username };
    return {
      ok: true,
      data: userData
    };
  },

  setUserToken: (userToken: string) => {
    // Mock implementation - just log the token
    console.log('Setting user token:', userToken);
  },

  register: async (email: string, childName: string, parentName: string, relation: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Registration successful",
        user: { email, childName, parentName, relation }
      }
    };
  },

  login: async (email: string, password: string, notificationToken: string, locale: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.login
    };
  },

  forgotPassword: async (email: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Password reset email sent"
      }
    };
  },

  logout: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Logged out successfully"
      }
    };
  },

  getMe: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.user
    };
  },

  updateNotificationToken: async (token: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Notification token updated"
      }
    };
  },

  getChildren: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.children
    };
  },

  attemptGoal: async (id: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Goal attempted successfully",
        goalId: id
      }
    };
  },

  updateNotesOfGoal: async (id: string, notes: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Notes updated successfully",
        goalId: id,
        notes
      }
    };
  },

  uploadImageToGoal: async (id: string, image: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Image uploaded successfully",
        goalId: id,
        imageId: "mock_image_id"
      }
    };
  },

  deleteImageFromGoal: async (id: string, imageId: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Image deleted successfully",
        goalId: id,
        imageId
      }
    };
  },

  getCalendarEvents: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: [
        {
          id: 1,
          title: "Test Event",
          date: "2024-01-15T10:00:00Z"
        }
      ]
    };
  },

  getAnnouncements: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.announcements
    };
  },

  updateProfilePic: async (id: string, image: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Profile picture updated successfully",
        childId: id
      }
    };
  },

  updateUserLocale: async (locale: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Locale updated successfully",
        locale
      }
    };
  },

  changePassword: async (password: string, old_password: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Password changed successfully"
      }
    };
  },

  getMyAppointments: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: mockData.appointments
    };
  },

  getAppointmentCategories: async (): Promise<ApiResponse> => {
    return {
      ok: true,
      data: [
        {
          id: 1,
          name: "General Checkup",
          description: "Regular health checkup"
        },
        {
          id: 2,
          name: "Specialist Consultation",
          description: "Specialist appointment"
        }
      ]
    };
  },

  getAppointmentTimeslots: async (categoryId: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: [
        {
          id: 1,
          time: "09:00",
          available: true
        },
        {
          id: 2,
          time: "10:00",
          available: true
        }
      ]
    };
  },

  bookAppointmentTimeslot: async (childId: string, categoryId: string, timeslotId: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Appointment booked successfully",
        appointmentId: "mock_appointment_id"
      }
    };
  },

  seenAnAnnouncement: async (announcementId: string): Promise<ApiResponse> => {
    return {
      ok: true,
      data: {
        message: "Announcement marked as seen",
        announcementId
      }
    };
  },
};
